import { render, staticRenderFns } from "./AgeRatingPickerInline.vue?vue&type=template&id=73442988&scoped=true"
import script from "./AgeRatingPickerInline.vue?vue&type=script&lang=js"
export * from "./AgeRatingPickerInline.vue?vue&type=script&lang=js"
import style0 from "./AgeRatingPickerInline.vue?vue&type=style&index=0&id=73442988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73442988",
  null
  
)

export default component.exports